import { gql } from "@apollo/client";

export const MODELS = gql`
  query vehicleModels {
    vehicleModels {
      id
      name
      is_actived
      brand {
        id
        name
      }
    }
    vehicleBrands {
      id
      name
    }
  }
`;

export default MODELS;
